/* BarBank header: drawer, compact-on-scroll, mega-menu a11y, predictive search overlay. No dependencies. */
(function () {
  if (window.__bbh) return; window.__bbh = 1;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var html = document.documentElement;
  var header = $('#bbh'); if (!header) return;
  var lastFocus = null;

  /* keep header full-bleed whatever padding the theme puts on #root */
  function syncPad() { var r = document.getElementById('root'); if (!r) return; var pl = getComputedStyle(r).paddingLeft; if (pl) html.style.setProperty('--bbh-rp', pl); }
  syncPad(); window.addEventListener('resize', syncPad, { passive: true });

  function lock(on) { html.classList.toggle('bbh-lock', on); }
  function trap(panel, e) {
    if (e.key !== 'Tab') return;
    var f = $$('a[href],button:not([hidden]),input,summary,[tabindex]:not([tabindex="-1"])', panel).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }

  /* ---------- compact on scroll ---------- */
  /* compact on scroll: the section keeps the FULL header height reserved (no layout shift -> no feedback loop),
     plus hysteresis so it can't flip-flop around one threshold */
  var wrap = header.parentElement, ticking = false, compact = false;
  function reserve() {
    if (compact) return;
    wrap.style.height = header.offsetHeight + 'px';
  }
  reserve(); window.addEventListener('resize', function () { if (!compact) { wrap.style.height = ''; reserve(); } }, { passive: true });
  window.addEventListener('load', reserve);
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      if (!compact && y > 120) { compact = true; header.classList.add('bbh--compact'); }
      else if (compact && y < 30) { compact = false; header.classList.remove('bbh--compact'); }
      ticking = false;
    });
  }, { passive: true });

  /* ---------- mega menu a11y (hover/focus handled in CSS) ---------- */
  $$('.bbh-has').forEach(function (li) {
    var a = li.querySelector('.bbh-nav__a');
    li.addEventListener('mouseenter', function () { a.setAttribute('aria-expanded', 'true'); });
    li.addEventListener('mouseleave', function () { a.setAttribute('aria-expanded', 'false'); li.classList.remove('is-open'); });
    li.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { li.classList.remove('is-open'); a.setAttribute('aria-expanded', 'false'); a.focus(); }
      if (e.key === 'ArrowDown' && document.activeElement === a) { e.preventDefault(); li.classList.add('is-open'); a.setAttribute('aria-expanded', 'true'); var f = li.querySelector('.bbh-mega a'); if (f) f.focus(); }
    });
  });

  /* ---------- drawer ---------- */
  var dr = $('#bbh-drawer'), burger = $('[data-bbh-open]');
  function openDrawer() {
    lastFocus = document.activeElement; dr.hidden = false; lock(true);
    requestAnimationFrame(function () { dr.classList.add('is-open'); });
    burger && burger.setAttribute('aria-expanded', 'true');
    var c = dr.querySelector('[data-bbh-close].bbh-ic'); c && c.focus();
  }
  function closeDrawer() {
    dr.classList.remove('is-open'); burger && burger.setAttribute('aria-expanded', 'false'); lock(false);
    setTimeout(function () { dr.hidden = true; }, 280); lastFocus && lastFocus.focus && lastFocus.focus();
  }
  burger && burger.addEventListener('click', openDrawer);
  $$('[data-bbh-close]', dr).forEach(function (b) { b.addEventListener('click', closeDrawer); });
  dr.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); trap(dr.querySelector('.bbh-dr__panel'), e); });

  /* ---------- search ---------- */
  var S = $('#bbh-search'), input = $('#bbh-q'), results = $('#bbh-results'), empty = $('.bbh-s__empty', S),
      clearBtn = $('.bbh-s__clear', S), live = $('.bbh-s__live', S), form = $('.bbh-s__form', S);
  var RKEY = 'bbh_recent', timer = null, ctrl = null, active = -1, lastQ = '';
  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function getRecent() { try { return JSON.parse(localStorage.getItem(RKEY) || '[]'); } catch (e) { return []; } }
  function saveRecent(q) {
    q = (q || '').trim(); if (q.length < 2) return;
    try { var r = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); r.unshift(q); localStorage.setItem(RKEY, JSON.stringify(r.slice(0, 6))); } catch (e) {}
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function hl(text, q) {
    var t = esc(text), words = q.trim().split(/\s+/).filter(function (w) { return w.length > 1; }).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    return words.length ? t.replace(new RegExp('(' + words.map(esc).join('|') + ')', 'gi'), '<mark>$1</mark>') : t;
  }
  function renderRecent() {
    var r = getRecent(), box = $('.bbh-s__recent', S), list = $('.bbh-s__recentlist', S);
    box.hidden = !r.length;
    list.innerHTML = r.map(function (q) { return '<button type="button" class="bbh-chip" data-q="' + esc(q) + '">' + esc(q) + '</button>'; }).join('');
  }
  function openSearch(prefill) {
    lastFocus = document.activeElement; S.hidden = false; lock(true); renderRecent();
    requestAnimationFrame(function () { S.classList.add('is-open'); input.focus(); if (prefill) { input.value = prefill; onInput(); } });
  }
  function closeSearch() {
    S.classList.remove('is-open'); lock(false); if (ctrl) ctrl.abort();
    setTimeout(function () { S.hidden = true; }, 180); lastFocus && lastFocus.focus && lastFocus.focus();
  }
  function showEmpty() { results.hidden = true; empty.hidden = false; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
  function items() { return $$('.bbh-r__item', results); }
  function setActive(i) {
    var list = items(); if (!list.length) return;
    active = (i + list.length) % list.length;
    list.forEach(function (el, n) { el.classList.toggle('is-active', n === active); el.setAttribute('aria-selected', n === active ? 'true' : 'false'); });
    input.setAttribute('aria-activedescendant', list[active].id); list[active].scrollIntoView({ block: 'nearest' });
  }

  function render(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var prods = r.products || [], cols = r.collections || [], qs = (r.queries || []).filter(function (x) { return x.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 4);
    var n = 0, h = '';
    if (qs.length) {
      h += '<div class="bbh-r__sec"><p class="bbh-s__h">Suggestions</p>' + qs.map(function (x) {
        return '<a class="bbh-r__q bbh-r__item" role="option" id="bbh-o' + (n++) + '" href="' + root + 'search?type=product&q=' + encodeURIComponent(x.text) + '" data-save="' + esc(x.text) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg><span>' + hl(x.text, q) + '</span></a>';
      }).join('') + '</div>';
    }
    if (cols.length) {
      h += '<div class="bbh-r__sec"><p class="bbh-s__h">Collections</p><div class="bbh-r__cols">' + cols.slice(0, 6).map(function (c) {
        return '<a class="bbh-r__col bbh-r__item" role="option" id="bbh-o' + (n++) + '" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
      }).join('') + '</div></div>';
    }
    if (prods.length) {
      h += '<div class="bbh-r__sec"><p class="bbh-s__h">Products</p>' + prods.map(function (p) {
        var price = parseFloat(p.price), cmp = parseFloat(p.compare_at_price_max || 0), sale = cmp > price, so = p.available === false;
        var base = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || ''), sep = base.indexOf('?') > -1 ? '&' : '?';
        var img = base ? base + sep + 'width=200' : '', img2 = base ? base + sep + 'width=400' : '';
        return '<a class="bbh-r__p bbh-r__item' + (so ? ' is-soldout' : '') + '" role="option" id="bbh-o' + (n++) + '" href="' + esc(p.url) + '">' +
          '<span class="bbh-r__img">' + (img ? '<img src="' + esc(img) + '" srcset="' + esc(img) + ' 200w, ' + esc(img2) + ' 400w" sizes="64px" alt="" width="64" height="64" loading="lazy">' : '') + '</span>' +
          '<span><span class="bbh-r__v">' + esc(p.vendor) + '</span><span class="bbh-r__t">' + hl(p.title, q) + '</span>' + (so ? '<span class="bbh-r__so">Sold out</span>' : '') + '</span>' +
          '<span class="bbh-r__pr' + (sale ? ' bbh-r__sale' : '') + '">' + (isNaN(price) ? '' : money.format(price)) + (sale ? '<s>' + money.format(cmp) + '</s>' : '') + '</span></a>';
      }).join('') + '</div>';
    }
    if (!prods.length && !cols.length && !qs.length) {
      h = '<p class="bbh-r__none">No results for <b>“' + esc(q) + '”</b>. Check the spelling or try a brand, like Blanton\'s or Fortaleza.</p>' + $('.bbh-s__chips:not(.bbh-s__recentlist)', S).outerHTML;
      live.textContent = 'No results';
    } else {
      live.textContent = prods.length + ' products found';
    }
    h += '<a class="bbh-r__all bbh-r__item" role="option" id="bbh-o' + (n++) + '" href="' + root + 'search?type=product&q=' + encodeURIComponent(q) + '" data-save="' + esc(q) + '">See all results for “' + esc(q) + '” →</a>';
    results.innerHTML = h; results.hidden = false; empty.hidden = true; input.setAttribute('aria-expanded', 'true'); active = -1;
  }

  function run(q) {
    if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
    results.hidden = false; empty.hidden = true;
    if (!results.querySelector('.bbh-r__sec')) results.innerHTML = '<div class="bbh-sk"></div><div class="bbh-sk"></div><div class="bbh-sk"></div>';
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); })
      .then(function (d) { if (q === lastQ) render(q, d); })
      .catch(function (e) { if (e && e.name === 'AbortError') return; results.innerHTML = '<p class="bbh-r__none">Search is having trouble. Press Enter to see full results.</p>'; });
  }
  function onInput() {
    var q = input.value.trim(); clearBtn.hidden = !input.value; lastQ = q; clearTimeout(timer);
    if (q.length < 2) { showEmpty(); return; }
    timer = setTimeout(function () { run(q); }, 140);
  }

  input.addEventListener('input', onInput);
  clearBtn.addEventListener('click', function () { input.value = ''; onInput(); input.focus(); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
    else if (e.key === 'Enter' && active > -1) { e.preventDefault(); var el = items()[active]; saveRecent(el.dataset.save || input.value); window.location.href = el.href; }
  });
  form.addEventListener('submit', function (e) { if (!input.value.trim()) { e.preventDefault(); return; } saveRecent(input.value); });
  S.addEventListener('click', function (e) {
    var chip = e.target.closest('.bbh-chip'); if (chip) { input.value = chip.dataset.q; onInput(); input.focus(); return; }
    var it = e.target.closest('.bbh-r__item'); if (it) saveRecent(it.dataset.save || input.value.trim());
    if (e.target.closest('.bbh-s__clearrecent')) { try { localStorage.removeItem(RKEY); } catch (x) {} renderRecent(); }
  });
  $$('[data-bbh-sclose]', S).forEach(function (b) { b.addEventListener('click', closeSearch); });
  S.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); trap(S.querySelector('.bbh-s__panel'), e); });
  $$('[data-bbh-search]').forEach(function (b) {
    b.addEventListener('click', function () { if (!dr.hidden) { dr.classList.remove('is-open'); dr.hidden = true; } openSearch(); });
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target, typing = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable);
    if (((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') || (e.key === '/' && !typing)) { if (S.hidden) { e.preventDefault(); openSearch(); } }
  });
})();
